<template>
    <div class="grey lighten-3 px-3 py-3">
        <v-list subheader class="grey lighten-3">
            <v-list-item-group>
                <v-subheader>Auswahloptionen für das Drucken Ihrer Tickets</v-subheader>
                <v-list-item v-model="switchActive">
                    <template v-slot:default="{ active }">
                        <v-list-item-action>
                            <v-checkbox
                                :input-value="active"
                                color="primary"
                            ></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title
                                >Mehrere Konzerte auswählen
                            </v-list-item-title>
                        </v-list-item-content>
                    </template>
                </v-list-item>
            </v-list-item-group>
        </v-list>
        <div
            class="d-flex flex-column flex-lg-row justify-space-between"
            v-if="printIsActive"
        >
            <v-btn text block @click="chooseAll()">
                Alle Konzerte auswählen
            </v-btn>
        </div>
        <div
            class="d-flex flex-column flex-lg-row justify-space-between"
            v-if="printIsActive"
        >
            <v-btn text block @click="chooseNone()">
                Alle Konzerte abwählen
            </v-btn>
        </div>

        <v-divider class="my-5"></v-divider>

        <v-list subheader class="grey lighten-3">
            <v-list-item-group v-model="filterByMonths" multiple>
                <v-subheader>Monate</v-subheader>
                <v-list-item v-for="(item, i) in allConcertsByMonth" :key="i">
                    <template v-slot:default="{ active }">
                        <v-list-item-action>
                            <v-checkbox
                                :input-value="active"
                                color="primary"
                            ></v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.month }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </template>
                </v-list-item>
            </v-list-item-group>
        </v-list>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
    methods: {
        ...mapActions(['changePrintState', 'setChosenMonths']),
        chooseAll() {
            this.changePrintState({ action: 'ADD_ALL' });
        },
        chooseNone() {
            this.changePrintState({ action: 'REMOVE_ALL' });
        },
    },
    computed: {
        ...mapGetters([
            'allConcertsByMonth',
            'amountOfPrintItems',
            'printIsActive',
            'allChosenMonths',
            'allMonthIndexes',
        ]),
        switchActive: {
            get() {
                return this.printIsActive;
            },
            set() {
                this.changePrintState({ action: 'TOGGLE_SELECT' });
            },
        },

        filterByMonths: {
            get() {
                return this.allChosenMonths;
            },
            set(newMonths) {
                this.setChosenMonths({ newMonths });
            },
        },
    },
};
</script>

<style></style>
